import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subscription-settings',
  templateUrl: './subscription-settings.component.html',
  styleUrls: ['./subscription-settings.component.scss']
})
export class SubscriptionSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
